"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8801],{

/***/ 60652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RQ": function() { return /* binding */ VARIANT_MAPS; },
/* harmony export */   "r4": function() { return /* binding */ SectionText; }
/* harmony export */ });
/* unused harmony export VARIANT_MAPS_TITLE */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77215);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23097);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89136);
/* harmony import */ var common_tags__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62123);
/* harmony import */ var _atoms__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38959);
/* harmony import */ var _atoms__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94557);
/* harmony import */ var _atoms__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97932);
/* harmony import */ var _atoms__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(60864);
/* harmony import */ var _atoms__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81246);
/* harmony import */ var _atoms__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(64903);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        flex gap-8 md:mb-6 md:gap-16\n        ",
        "\n        ",
        "\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            max-w-[802px] justify-between\n            ",
        "\n            ",
        "   \n          "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n              text-heading text-heading-mobile--h2 !font-normal md:text-heading--h2 \n              ",
        "\n              ",
        "\n            "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            flex max-w-[802px]  flex-col gap-4\n            ",
        "\n            ",
        "\n            ",
        " \n           \n          "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n                  mb-5  break-keep !text-[20px]  !font-light  leading-[28px] md:mb-6\n                  ",
        "\n                  ",
        "\n                  ",
        "\n                "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var TEXT_ALIGN_MAPS = {
    center: "flex md:justify-center md:text-center",
    end: "flex md:justify-end md:text-end",
    start: "flex md:justify-start md:text-start"
};
var TEXT_ALIGN_MAPS_MOBILE = {
    center: "flex justify-center text-center",
    end: "flex justify-end text-end",
    start: "flex justify-start text-start"
};
var VARIANT_MAPS = {
    primary: "text-primary-400",
    secondary: "text-secondary-400",
    alternative: "text-white"
};
var VARIANT_MAPS_TITLE = {
    primary: "!text-brownie-500",
    secondary: "text-secondary-400",
    alternative: "text-white"
};
var SectionText = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, caption = param.caption, desc = param.desc, direction = param.direction, textAlign = param.textAlign, textAlignMobile = param.textAlignMobile, title = param.title, caracteristics = param.caracteristics, variant = param.variant, _caracCols = param.caracCols, caracCols = _caracCols === void 0 ? 2 : _caracCols, directionMobile = param.directionMobile, _showSeeMore = param.showSeeMore, showSeeMore = _showSeeMore === void 0 ? false : _showSeeMore, subtitle = param.subtitle;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("common").t;
    var rowCarac = direction === "row" && directionMobile === "row" && !caracteristics;
    var captionAlignment = direction === "column" ? textAlign === "center" ? "md:justify-center md:items-center" : textAlign === "end" ? "md:justify-end md:items-end" : "md:justify-start md:items-start" : "";
    var MobileAlignment = direction === "column" ? textAlignMobile === "center" ? "justify-center items-center" : textAlignMobile === "end" ? "justify-end items-end" : "justify-start items-start" : "";
    /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */ /* @ts-ignore */ var labels = t("components.atoms.seeMore.labels", "common", {
        returnObjects: true
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: (0,common_tags__WEBPACK_IMPORTED_MODULE_3__/* .oneLine */ .f9)(_templateObject(), rowCarac ? "flex-row" : "\n              ".concat(directionMobile === "row" ? "flex-row " : "flex-col", "  \n              ").concat(direction === "row" ? "justify-between md:flex-row " : "md:flex-col", "\n            "), className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: rowCarac ? "w-full max-w-fit md:w-full" : direction === "row" ? "w-full max-w-fit md:w-1/2" : "",
                children: [
                    caption && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        align: textAlign,
                        className: "mb-4 ".concat(captionAlignment, " ").concat(MobileAlignment),
                        mobileAlignment: textAlignMobile !== null && textAlignMobile !== void 0 ? textAlignMobile : textAlign,
                        variant: variant,
                        children: caption
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: (0,common_tags__WEBPACK_IMPORTED_MODULE_3__/* .oneLine */ .f9)(_templateObject1(), TEXT_ALIGN_MAPS[textAlign], TEXT_ALIGN_MAPS_MOBILE[textAlignMobile !== null && textAlignMobile !== void 0 ? textAlignMobile : textAlign]),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                            className: (0,common_tags__WEBPACK_IMPORTED_MODULE_3__/* .oneLine */ .f9)(_templateObject2(), VARIANT_MAPS_TITLE[variant], !caracteristics ? "w-full" : "sm:w-1/2"),
                            dangerouslySetInnerHTML: {
                                __html: title
                            }
                        })
                    }),
                    subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "mt-6",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
                            className: "text-heading text-heading--h5 ".concat(VARIANT_MAPS[variant]),
                            children: subtitle
                        })
                    })
                ]
            }),
            desc || caracteristics ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: (0,common_tags__WEBPACK_IMPORTED_MODULE_3__/* .oneLine */ .f9)(_templateObject3(), showSeeMore ? "sm:flex-col" : "sm:flex-row", rowCarac ? "w-full md:w-1/2" : "", direction === "row" && !caracteristics ? "w-full md:w-1/2" : ""),
                children: [
                    desc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        condition: showSeeMore,
                        wrapper: function(children) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                heigthPx: 150,
                                expanded: false,
                                labels: {
                                    viewLess: labels.viewLess,
                                    viewMore: labels.viewMore
                                },
                                children: children
                            });
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            html: desc,
                            className: (0,common_tags__WEBPACK_IMPORTED_MODULE_3__/* .oneLine */ .f9)(_templateObject4(), !caracteristics ? "w-full" : "w-full md:w-1/2", VARIANT_MAPS[variant], TEXT_ALIGN_MAPS[textAlign])
                        })
                    }),
                    caracteristics ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: 'sm:before:content-[" "] flex w-full flex-row sm:w-1/2 sm:before:mr-5 sm:before:block sm:before:h-auto sm:before:w-px sm:before:border-l sm:before:border-primary-400 ',
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            className: "w-full !gap-3 text-primary-400 ",
                            xs: caracCols,
                            md: caracCols,
                            lg: caracCols,
                            children: caracteristics.map(function(child, index) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_atoms__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Item */ .Z.Item, {
                                    className: "flex flex-row gap-1",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                            src: child.icon,
                                            width: 20,
                                            height: 20
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                            className: "text-body text-body--secondary",
                                            children: child.text
                                        })
                                    ]
                                }, index);
                            })
                        })
                    }) : null
                ]
            }) : null
        ]
    });
};
SectionText.displayName = "SectionText";


/***/ }),

/***/ 67526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _SectionText__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60652);

/* harmony default export */ __webpack_exports__["Z"] = (_SectionText__WEBPACK_IMPORTED_MODULE_0__/* .SectionText */ .r4);


/***/ }),

/***/ 97932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ see_more; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(43291);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(89136);
// EXTERNAL MODULE: ./components/atoms/link/index.ts + 1 modules
var atoms_link = __webpack_require__(27594);
// EXTERNAL MODULE: ./components/atoms/icon/index.ts + 2 modules
var atoms_icon = __webpack_require__(64903);
// EXTERNAL MODULE: ./lib/utils/utils.tsx
var utils = __webpack_require__(52994);
;// CONCATENATED MODULE: ./components/atoms/see-more/SeeMore.tsx






/**
 * SeeMore
 */ var SeeMore = function(param) {
    var children = param.children, _expanded = param.expanded, expanded = _expanded === void 0 ? false : _expanded, _variant = param.variant, variant = _variant === void 0 ? "primary" : _variant, labels = param.labels, heigthPx = param.heigthPx, numberOfElements = param.numberOfElements, icon = param.icon, className = param.className, _hideLabel = param.hideLabel, hideLabel = _hideLabel === void 0 ? false : _hideLabel;
    var ref = (0,react.useState)(expanded), isExpanded = ref[0], setExpanded = ref[1];
    var t = (0,useTranslation/* default */.Z)("common").t;
    var toggle = function(state) {
        setExpanded(state);
    };
    var firstChild = (0,utils/* toArray */.qo)(children)[0];
    var firstChildRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(expanded), seeMore = ref1[0], setSeeMore = ref1[1];
    (0,react.useEffect)(function() {
        var ref;
        /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */ /* @ts-ignore */ setSeeMore((firstChildRef === null || firstChildRef === void 0 ? void 0 : (ref = firstChildRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight) > heigthPx);
    }, [
        firstChildRef,
        heigthPx
    ]);
    (0,react.useEffect)(function() {
        var ref;
        /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */ /* @ts-ignore */ setSeeMore((firstChildRef === null || firstChildRef === void 0 ? void 0 : (ref = firstChildRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight) > heigthPx);
    }, [
        heigthPx
    ]);
    if (!labels) {
        /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */ /* @ts-ignore */ labels = t("components.atoms.seeMore.labels", "common", {
            returnObjects: true
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            numberOfElements ? (0,utils/* toArray */.qo)(children).map(function(child, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat(index < numberOfElements ? "h-full min-h-full min-w-full opacity-100" : isExpanded ? "h-full min-h-full min-w-full opacity-100" : "h-0 opacity-0 ", " col-span-2 transition-all duration-500 md:col-span-1"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(child.type, (0,_object_spread/* default */.Z)({}, child.props, typeof child.type === "function" ? {
                        seen: index < numberOfElements ? true : isExpanded ? true : false
                    } : {}))
                }, index);
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative h-full transform overflow-hidden transition-all duration-500 ".concat(isExpanded ? "max-h-[1000px]" : "".concat(seeMore ? "after:absolute after:bottom-0 after:left-0 after:right-0 after:h-[35px] after:bg-gradient-to-t after:from-white after:to-[rgba(248,247,246,0.3)] after:content-['']" : "")),
                style: {
                    maxHeight: !isExpanded ? "".concat(heigthPx, "px") : "1000px"
                },
                children: firstChild && /*#__PURE__*/ react.cloneElement(firstChild, {
                    ref: firstChildRef
                })
            }),
            (children === null || children === void 0 ? void 0 : children.length) > numberOfElements || seeMore ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "z-10 col-start-1 col-end-[-1] mt-2 flex ".concat(!hideLabel && "w-full", " cursor-pointer flex-row items-center justify-center gap-2 ").concat(className),
                onClick: function() {
                    return toggle(!isExpanded);
                },
                children: [
                    !hideLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_link/* default */.Z, {
                        as: "span",
                        variant: variant,
                        arrow: false,
                        children: isExpanded ? labels === null || labels === void 0 ? void 0 : labels.viewLess : labels === null || labels === void 0 ? void 0 : labels.viewMore
                    }),
                    icon ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "transform transition-all duration-500 ".concat(isExpanded ? "rotate-180" : "rotate-0", "\n            "),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_icon/* default */.Z, {
                            height: 10,
                            width: 10,
                            src: icon
                        })
                    }) : null
                ]
            }) : null
        ]
    });
};
SeeMore.displayName = "SeeMore";

;// CONCATENATED MODULE: ./components/atoms/see-more/index.ts

/* harmony default export */ var see_more = (SeeMore);


/***/ }),

/***/ 68801:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ gallery_template; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(43291);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(60123);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(46572);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/atoms/container/index.ts + 1 modules
var container = __webpack_require__(82112);
// EXTERNAL MODULE: ./components/atoms/section-text/index.ts
var section_text = __webpack_require__(67526);
// EXTERNAL MODULE: ./components/atoms/button/index.ts + 1 modules
var atoms_button = __webpack_require__(60825);
// EXTERNAL MODULE: ./components/atoms/link/index.ts + 1 modules
var atoms_link = __webpack_require__(27594);
// EXTERNAL MODULE: ./components/atoms/multimedia/index.ts + 1 modules
var multimedia = __webpack_require__(89381);
;// CONCATENATED MODULE: ./components/templates/gallery-template/GalleryTemplate.tsx






var PopUpIframe = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5518), __webpack_require__.e(8230)]).then(__webpack_require__.bind(__webpack_require__, 48230));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(48230)
            ];
        }
    },
    ssr: false
});
/**
 * GalleryTemplate
 */ var GalleryTemplate = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, backgroundColorBottom = param.backgroundColorBottom, backgroundColorBottomMobile = param.backgroundColorBottomMobile, backgroundColorTop = param.backgroundColorTop, backgroundColorTopMobile = param.backgroundColorTopMobile, button = param.button, caption = param.caption, _cutLevel = param.cutLevel, cutLevel = _cutLevel === void 0 ? 50 : _cutLevel, _cutLevelMobile = param.cutLevelMobile, cutLevelMobile = _cutLevelMobile === void 0 ? 50 : _cutLevelMobile, desc = param.desc, multimediaProps = param.multimediaProps, link = param.link, subTitle = param.subTitle, textColor = param.textColor, title = param.title, index = param.index, id = param.id;
    var ref = (0,react.useState)(false), popUpState = ref[0], setPopUpState = ref[1];
    var popUpToggle = function() {
        setPopUpState(!popUpState);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* default */.Z, {
        index: index,
        backgroundColorBottom: backgroundColorBottom,
        backgroundColorTopMobile: backgroundColorTopMobile,
        backgroundColorTop: backgroundColorTop,
        backgroundColorBottomMobile: backgroundColorBottomMobile,
        cutLevel: cutLevel === null ? 50 : cutLevel,
        cutLevelMobile: cutLevelMobile === null ? 50 : cutLevel,
        className: "mx-0 flex flex-col gap-10 lg:flex-row lg:gap-32 ".concat(className),
        id: id,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-4 lg:w-1/2 lg:gap-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(section_text/* default */.Z, {
                        textAlign: "start",
                        variant: textColor,
                        direction: "column",
                        subtitle: subTitle,
                        desc: desc,
                        title: title,
                        caption: caption,
                        showSeeMore: true,
                        className: "w-auto"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "hidden flex-col gap-10 lg:flex lg:flex-row",
                        children: [
                            (button === null || button === void 0 ? void 0 : button.iframe) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PopUpIframe, {
                                        className: "rounded-md bg-white",
                                        setState: popUpToggle,
                                        state: popUpState,
                                        src: button.iframe
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                                        onClick: popUpToggle,
                                        size: "large",
                                        variant: button.variant,
                                        children: button.label
                                    })
                                ]
                            }),
                            (link === null || link === void 0 ? void 0 : link.label) && (link === null || link === void 0 ? void 0 : link.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: link.src,
                                passHref: true,
                                prefetch: false,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_link/* default */.Z, {
                                    arrow: link.variant !== "outline",
                                    variant: link.variant,
                                    children: link.label
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-64 w-full lg:mt-4 lg:h-[367px] lg:w-1/2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(multimedia/* default */.Z, (0,_object_spread/* default */.Z)({}, multimediaProps))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex w-full flex-col items-center justify-center gap-7 lg:hidden lg:gap-10",
                children: [
                    button.iframe && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                        onClick: popUpToggle,
                        className: "w-full",
                        size: "large",
                        variant: button.variant,
                        children: button.label
                    }),
                    (link === null || link === void 0 ? void 0 : link.src) && (link === null || link === void 0 ? void 0 : link.label) && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        passHref: true,
                        prefetch: false,
                        href: link.src,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_link/* default */.Z, {
                            arrow: true,
                            variant: link.variant,
                            href: link.src,
                            children: link.label
                        })
                    })
                ]
            })
        ]
    });
};
GalleryTemplate.displayName = "GalleryTemplate";

;// CONCATENATED MODULE: ./components/templates/gallery-template/index.ts

/* harmony default export */ var gallery_template = (GalleryTemplate);


/***/ })

}]);